import { render, staticRenderFns } from "./MallV2ImagePicker.vue?vue&type=template&id=288108ac&scoped=true"
import script from "./MallV2ImagePicker.vue?vue&type=script&lang=js"
export * from "./MallV2ImagePicker.vue?vue&type=script&lang=js"
import style0 from "./MallV2ImagePicker.vue?vue&type=style&index=0&id=288108ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288108ac",
  null
  
)

export default component.exports